<div class="full-page" [ngClass]="{'allowSafeArea': allowSafeArea()}"
     woa-responsive [pillarboxedOnMobile]="pillarboxedOnMobile()" [pillarboxedOnDesktop]="pillarboxedOnDesktop()"
     woa-swipable [swipeEnabled]="enableSwipeRefresh() && responsiveService.mobile()"
     [swipeScale]="0.3" [swipeEase]="true" [swipeRangeDistance]="150" [swipePrimeProportionOfRange]="0.85"
     [swipeScroller]="pageScrollerER()" (onSwipe)="onRefresh.emit()">
    @if (enableSwipeRefresh() && responsiveService.mobile()) {
        <div class="swipe-refresh">
            <div class="swipe-refresh-indicator">
                <woa-icon class="swipe-refresh-indicator-icon" name="rotate-left"></woa-icon>
            </div>
        </div>
    }
    @if (showNavbar()) {
        <div class="navbar" woa-responsive>
            <div class="navbar-buttons left">
                @if (navigationService.canDismissView() && !hideBackButton() && (responsiveService.mobile() || showBackButtonOnDesktop())) {
                    <woa-icon-button class="navbar-buttons-button back" [type]="IconButtonType.BACK"
                                     [limitClickRate]="false" (onActivate)="back()"></woa-icon-button>
                }
                <ng-content select="[slot=navbar-left]"></ng-content>
            </div>
            <div class="navbar-title">
                @if (showNavbarLogo()) {
                    <woa-logo class="navbar-title-logo" [type]="'horizontal'"></woa-logo>
                }
                @if (navbarTitle()) {
                    <div class="navbar-title-text">
                        {{ navbarTitle() | translate: translationParams() }}
                    </div>
                }
            </div>
            <div class="navbar-buttons right">
                <ng-content select="[slot=navbar-right]"></ng-content>
                @if (showRefreshButton()) {
                    <woa-icon-button class="navbar-buttons-button refresh" [type]="IconButtonType.REFRESH"
                                     (onActivate)="onRefresh.emit()"></woa-icon-button>
                }
            </div>
        </div>
    }
    @if (!showNavbar() && navigationService.canDismissView() && !hideBackButton() && (responsiveService.mobile() || showBackButtonOnDesktop())) {
        <woa-icon-button class="navbar-buttons-button back floating" [class.circular]="makeFloatingBackButtonCircular()"
                         [type]="IconButtonType.BACK" [circular]="makeFloatingBackButtonCircular()"
                         [limitClickRate]="false" (onActivate)="back()"></woa-icon-button>
    }
    <div class="background"
         [ngClass]="{'transparent': transparent()}"
         [woa-background-image]="[{
             conditional: true,
             on: showLoginBackgroundImage(),
             image: appData(configurationModel.app())?.loginImage,
             opacity: appData(configurationModel.app())?.loginImageOpacity,
             classes: 'theme-standard-page-image-color-pair'
         }, {
             classes: 'theme-' + backgroundColorPair() + '-color-pair',
             conditional: false
         }]">
        <div class="page-content"
             [ngClass]="{
                 'with-divider': responsiveService.desktop() && pillarboxedOnDesktop() === 'double-mobile',
                 'with-title': navbarTitle() || showNavbarLogo()
             }">
            <div class="scroller" #scroller>
                @if (showContent()) {
                    <div class="page-content-body" [ngClass]="{'locked': contentLocked()}" woa-responsive>
                        @if (showTitles() && (title() || subtitle())) {
                            <div class="page-content-body-titles">
                                @if (title()) {
                                    <div class="page-content-body-titles-title">
                                        {{ title() | translate: translationParams() }}
                                    </div>
                                }
                                @if (showSubtitle() && subtitle()) {
                                    <div class="page-content-body-titles-subtitle">
                                        {{ subtitle() | translate: translationParams() }}
                                    </div>
                                }
                            </div>
                        }
                        <div class="page-content-body-messages">
                            <ng-content select="woa-content-message"></ng-content>
                        </div>
                        <div class="page-content-body-main" [class.hidden]="!showContent()"
                             [ngClass]="{'double-pillarboxed': responsiveService.desktop() && pillarboxedOnDesktop() === 'double-mobile'}">
                            <!-- formatting of the following divs is to ensure no whitespace content when empty so that css :empty selector can work -->
                            <div class="page-content-body-main-section"
                                 [ngClass]="{'left': responsiveService.desktop() && pillarboxedOnDesktop() === 'double-mobile'}">
                                <ng-content select="[slot=content-left]"></ng-content>
                            </div>
                            <div class="page-content-body-main-section">
                                <ng-content></ng-content>
                            </div>
                            <div class="page-content-body-main-section"
                                 [ngClass]="{'right': responsiveService.desktop() && pillarboxedOnDesktop() === 'double-mobile'}">
                                <ng-content select="[slot=content-right]"></ng-content>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
        @if (showFooter()) {
            <div class="page-footer"
                 [ngClass]="{'with-footer-shadow': showFooterShadow() || (showFooterShadow() === undefined && footerControls().length)}">
                <woa-footer-messages>
                    <ng-content select="woa-footer-message, [slot=footer-messages]" slot="messages"></ng-content>
                </woa-footer-messages>
                <div class="page-footer-main">
                    <ng-content select="[slot=footer-start]"></ng-content>
                    @if (footerControls().length) {
                        <div class="page-footer-main-controls {{footerControlOrientation()}}">
                            <ng-content select="[woa-page-footer-control]"></ng-content>
                        </div>
                    }
                    <ng-content select="[slot=footer-end]"></ng-content>
                </div>
            </div>
        }
    </div>
</div>
